// @ts-nocheck
import React from "react";
import TabularData from "../../forecastGraphs/TabularData";
import { AssetGraphService } from "../hooks/assetGraphService";
import { flattenComposedForecast } from "../../../utils/composedForecastDashboardUtils";

// This component renders the asset graph data in a tabular format
// based on the selected forecast, variation, and interpolation settings.
// It builds flat data for the table using the AssetGraphService.
const AssetGraphTable = ({
  activeForecast,
  forecastVariation,
  interpolateChecked,
  processedModelData,
  composedForecastData,
  precipitation,
  wind10,
  wind80,
  windPower80Data,
  solarPowerData,
  solarRadiation,
  temperature2m,
  humidity2m,
  soilMoisture,
  snowAcc,
  highResPrecip,
  highResWind10,
  highResWind80,
  highResWindPower80Data,
  highResSolar,
  highResTemp,
  highResHumidity,
  timeZone,
  renderLoading,
}) => {
  // Composed forecasts take a separate path: the rows come from the
  // CombinedPreviewData cache, flattened into time-keyed rows. Bail early
  // with loading until the fetch resolves.
  if (activeForecast?.startsWith("composed-")) {
    const forecastId = activeForecast.slice("composed-".length);
    const combined = composedForecastData?.[forecastId];
    const composedRows = flattenComposedForecast(combined);
    if (!composedRows.length) {
      return renderLoading();
    }
    return <TabularData data={composedRows} yaxis="" timeZone={timeZone} />;
  }

  const flatData = AssetGraphService.buildFlatData({
    forecast: activeForecast,
    fcVariation: forecastVariation,
    interpolateChecked,
    processedModelData,
    precipitation,
    wind10,
    wind80,
    windPower80Data,
    solarPowerData,
    solarRadiation,
    temperature2m,
    humidity2m,
    soilMoisture,
    snowAcc,
    highResPrecip,
    highResWind10,
    highResWind80,
    highResWindPower80Data,
    highResSolar,
    highResTemp,
    highResHumidity,
  });
  // If flatData is not available, render loading state
  if (!flatData) {
    return renderLoading();
  }
  // Define y-axis labels for different forecasts
  const yAxisLabels = {
    Precipitation: "Millimeters (mm)",
    Wind10: {
      Speed: "Meter per Second (m/s)",
      Direction: "Degrees",
    },
    Wind80: {
      Speed: "Meter per Second (m/s)",
      Direction: "Degrees",
      Power: "Megawatt (MW)",
    },
    Solar: "Radiation Flux (W/m²)",
    Temperature: "Temperature (°C)",
    Humidity: "Relative Humidity (%)",
    SnowAcc: "Snow Water Equivalent (mm)",
  };

  let yaxis; // y-axis label to be determined based on forecast type

  // Determine the appropriate y-axis label based on the active forecast
  if (activeForecast === "Precipitation") {
    yaxis = yAxisLabels.Precipitation;
  } else if (activeForecast === "Wind10" || activeForecast === "Wind80") {
    yaxis = yAxisLabels[activeForecast][forecastVariation];
  } else if (activeForecast === "Solar") {
    yaxis = yAxisLabels.Solar;
  } else if (activeForecast === "Temperature") {
    yaxis = yAxisLabels.Temperature;
  } else if (activeForecast === "Humidity") {
    yaxis = yAxisLabels.Humidity;
  } else if (activeForecast === "SnowAcc") {
    yaxis = yAxisLabels.SnowAcc;
  } else if (activeForecast.includes("processed-")) {
    const processedActiveForecast = activeForecast.split("-")[1];
    yaxis =
      processedModelData?.[processedActiveForecast]?.models[forecastVariation]
        .yUnit;
  }

  return <TabularData data={flatData} yaxis={yaxis} timeZone={timeZone} />;
};

export default AssetGraphTable;
